import {
  CABIN_CODE,
  CHECK_IN_STATUS,
  PASSENGER_LOYALTY_TYPE,
  PASSENGER_TICKET_TYPE,
  PASSENGER_TYPE_CATEGORY,
  PRODUCT_CODE,
  SEAT_ASSIGN_STATUS
} from '../constants/travel-reservation.enum';

export interface TravelReservation_PaxType {
  id: string;
  code: string;
  name: string;
  category: PASSENGER_TYPE_CATEGORY;
}
export interface TravelReservation_PaxSegment_SeatAssignments {
  seat: {
    actualCabinClass: [TravelReservation_Cabin_Class];
    column: string;
    number: string;
    seatRow: {
      number: number;
    };
  };
  seatAssignmentType: SEAT_ASSIGN_STATUS;
}

export interface TravelReservation_Cabin_Class {
  code: CABIN_CODE;
  name: string;
  productCode: PRODUCT_CODE;
  productName?: string;
}

export interface TravelReservation_PaxSegment_PaxLegs {
  legId: number;
  seatAssignments: TravelReservation_PaxSegment_SeatAssignments[];
  redEye: boolean;
}

export interface TravelReservation_PaxTicket {
  number: string;
  deliveryType: PASSENGER_TICKET_TYPE;
  encryptedNumber?: string;
  issueDt?: string;
  posCurrencyCode?: string;
  posCityCode?: string;
}

export interface TravelReservation_Passenger {
  passengerResourceId: string;
  givenNames: string;
  surname: string;
  firstNameNum?: string;
  lastNameNum?: string;
  customerId?: string;
  infant?: TravelReservation_Passenger;
  passengerType?: TravelReservation_PaxType;
  tickets?: TravelReservation_PaxTicket[];
  loyaltyProgramAccounts?: TravelReservation_PaxLoyaltyAcc[];
  passengerTrips?: TravelReservation_PaxTrip[];
  groupLeader?: boolean;
  title?: string;
  gender?: string;
  earnedMiles?: number;
  middleName?: string;
  suffix?: string;
}

export interface TravelReservation_PaxLoyaltyAcc {
  loyaltyProgram: {
    name: string;
    owner: TravelReservation_PaxLoyaltyAcc_Owner[];
  };
  number: string;
  tierLevelCode: PASSENGER_LOYALTY_TYPE;
  tierLevelName: string;
  tierFullLevelName: string;
  tierLevelPriority: string;
  threeSixtyMember: boolean;
}

export interface TravelReservation_PaxTrip {
  tripId: number;
  checkinStatus: CHECK_IN_STATUS;
  passengerSegments: TravelReservation_PaxSegment[];
}

export interface TravelReservation_PaxLoyaltyAcc_Owner {
  code: string;
  name: string;
}

export interface TravelReservation_PaxSegment {
  segmentId: number;
  bookedCabinClass: TravelReservation_Cabin_Class;
  checkinStatus: CHECK_IN_STATUS;
  passengerLegs: TravelReservation_PaxSegment_PaxLegs[];
}
